module.exports = __webpack_public_path__ + "static/media/ThePowerOfNature.bd712a83.mp3";